import { Stack, Typography } from '@mui/material'
import { CarrierVisitStatusChip, useMinimalsTheme } from '@tom-ui/ui'

import { useTranslate } from '@tolgee/react'
import { CarrierVisitDirection } from '@yard/app/api'
import { CarrierVisitOverviewData } from '@yard/pages/YardSetup/stores/carrier-visit-overview.viewstore'
import { observer } from 'mobx-react-lite'
import { CarrierVisitOverviewCard } from '../../organisms/CarrierVisitOverview/CarrierVisitOverviewCard'

type Props = {
  date: string
  carrierVisits: CarrierVisitOverviewData[]
  onEdit: (carrierVisitId: number, direction: CarrierVisitDirection) => void
}

export const CarrierVisitOverviewCardsByDate = observer((props: Props) => {
  const { date, carrierVisits, onEdit } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <>
      <Stack
        p={theme.customSpacing.xxs}
        spacing={2}
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: theme.palette.common.white,
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          textAlign: 'center',
          zIndex: 1,
        }}
      >
        <Typography variant='captionBold'>{date}</Typography>
      </Stack>
      {carrierVisits.map(visit => (
        <CarrierVisitOverviewCard
          key={visit.id}
          name={visit.name}
          carrierType={visit.carrierType}
          visitTimestamp={visit.visitTimestamp}
          statusChip={<CarrierVisitStatusChip status={visit.status} />}
          indicators={visit.indicators.map(indicator => ({
            ...indicator,
            key: `${visit.id}-${indicator.direction}`,
            label: t(indicator.direction),
            onEdit: () => onEdit(visit.id, indicator.direction),
          }))}
        />
      ))}
    </>
  )
})
